<script>
import Input from "@/components/c-input";
// import Button from "@/components/c-button";
// import Select from "@/components/c-select";
// import i18n from "../../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
    // Button,
    // Select,
  },
  data() {
    return {

      valueShare: 0,
      valueAmount: 0


    };
  },
  mounted() {


  },
  methods: {
    
    formatCurrency: function(value, sign = '$', decimal = '.00') {
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    
    getValue: function() {
      return {
        project_id: this.item.project_id,
        project_owner_id: this.item.project_owner_id,
        share: this.valueShare,
        share_amount: this.valueAmount,
        notation: '',
      };
    },

    
    
  },
  props: {
    item: null,
    index: {
      type: Number,
      default: 0
    },
    isNew: {
      type: Boolean,
      default: true
    },
    ownerDataList: [],
  },
};
</script>
<template>
  <div class="row" style="font-size: 22px; margin-bottom: 20px;">
    
    <div class="col-md-6">
      {{item.name}}
    </div>
    <div class="col-md-2" style="text-align: right">
      <div v-if="isNew" class="row">
        <div class="col-md-5"></div>
        <div class="col-md-5">
          <Input 
            :type="'number'"
            :id="`share_${index}`"
            v-model="valueShare"   />
        </div>
        <div class="col-md-2">
          %
        </div>
      </div>
      <div v-else class="row">
        <div class="col-lg-7"></div>
        <div class="col-lg-5">{{item.share}} %</div>
      </div>
    </div>
    <div class="col-md-4" style="text-align: right">{{formatCurrency(item.share_amount)}}</div>    

  </div>
</template>